export type Type = "status" | "category";
export type FILTER_STATUS = "CHECKED" | "UNCHECKED" | "SELECTED";

export type FilterSelected = {
  value: string;
  status: FILTER_STATUS;
  is_hidden?: boolean;
  is_auto_select?: boolean;
  label?: string;
  text?: string;
  id?: string | number;
};
export type MappedItem = {
  text: string;
  value: string;
  selected: boolean;
  id?: string | number | undefined;
  isDefault: boolean;
  is_hidden: boolean;
  is_auto_select: boolean;
  can_be_deleted?: boolean;
};

export const FONT_SIZE_SEARCH_AREA = {
  small: 14,
  medium: 17,
  large: 20,
};

export const HEIGHT_SEARCH_AREA = {
  small: 24,
  medium: 29,
  large: 36,
};
